class RecommendedProductCard extends HTMLElement {
    static cache = new Map();

    constructor() {
        super();

        this.addEventListener('variantchange', e => this.update(e.detail.variant));

        this.addEventListener('dropdownopen', e => this.setOverflow());
        this.addEventListener('dropdownclose', e => this.removeOverflow());

        this.addEventListener('modalopen', e => this.setOverflow(false));
        this.addEventListener('modalstartclose', e => this.removeOverflow());

        this.handle = this.getAttribute('handle');
    }

    connectedCallback() {
        if (RecommendedProductCard.cache.has(this.handle)) {
            this.classList.add('no-animation');
            this.load();
        } else {
            const observer = new IntersectionObserver(entries => {
                if (entries.some(e => e.isIntersecting)) {
                    this.load();
                    observer.disconnect();
                }
            });

            observer.observe(this);
        }
    }

    setOverflow(transition = true) {
        const parent = this.closest('.recommended-cards-wrapper');
        if (parent) {
            if (!transition) parent.classList.add('no-transition');
            else parent.classList.remove('no-transition');

            setTimeout(() => {
                const overflow = this.scrollHeight - this.clientHeight;
                if (overflow > 0) {
                    parent.style.setProperty('--overflow', `${overflow + 16}px`);  
                }
            });
        }
    }

    removeOverflow() {
        const parent = this.closest('.recommended-cards-wrapper');
        if (parent) parent.style.removeProperty('--overflow');
    }

    update(variant) {
        this.querySelector('.recommended-product-card__price').innerHTML = variant.priceTextShort;

        const button = this.querySelector('.recommended-product-card__button');
        button.querySelector('span').innerHTML = variant.addToCartLabel;
        button.disabled = !variant.addToCartEnabled;
    }

    async load() {
        if (RecommendedProductCard.cache.has(this.handle)) {
            this.innerHTML = RecommendedProductCard.cache.get(this.handle);
        }
        else {
            const resp = await fetch(`/products/${this.handle}?view=recommended-product-card-contents`);

            if (resp.ok) {
                const html = await resp.text();
                this.innerHTML = html;
                RecommendedProductCard.cache.set(this.handle, html);
            }
            else this.remove();
        }

        const button = this.querySelector('.recommended-product-card__button:not([no-atc])');
        const variantSelector = this.querySelector('variant-selector');

        if (button && variantSelector) {
            button.addEventListener('click', async () => {
                if (button.disabled) return;

                const variantSelector = this.querySelector('variant-selector');
                if (!variantSelector) return;

                button.classList.add('show-loading');
                
                const error = await variantSelector.addToCart();

                if (!error) {
                    button.classList.add('recommended-product-card__button--added');
                    setTimeout(() => button.classList.remove('recommended-product-card__button--added'), 2000);
                }

                button.classList.remove('show-loading');
            });

            const parentSelector = this.closest('.product-main-wrapper').querySelector('.product-form > variant-selector');

            if (parentSelector) {
                parentSelector.addEventListener('variantchange', () => this.updateSize());
                this.updateSize();
            }
        }   
    }

    updateSize() {
        const productSelect = this.closest('.product-main-wrapper').querySelector('.product-form select[name="id"]');
        if (!productSelect) return;

        const selected = productSelect.selectedOptions[0];
        const size = selected ? selected.dataset.optionSize : null;

        if (size) {
            const targetSize = size.split('(')[0].trim();

            for (const sizeOption of this.querySelectorAll('input[name="size"]')) {
                const sizeValue = sizeOption.value.split('(')[0].trim();

                if (sizeValue === targetSize) {
                    sizeOption.click();
                    break;
                }
            }
        }
    }
}

customElements.define('recommended-product-card', RecommendedProductCard);


class NostoRecommendedCards extends HTMLElement {
    constructor() {
        super();

        this.prevScroll = null;

        const observer = new MutationObserver(() => {
            const cardsElem = this.querySelector('.recommended-cards');
            cardsElem.onscroll = () => this.prevScroll = cardsElem.scrollLeft;

            if (this.prevScroll) cardsElem.scrollLeft = this.prevScroll;
        });

        observer.observe(this, { childList: true });
    }
}


customElements.define('nosto-recommended-cards', NostoRecommendedCards);